import type { ColGroupDef } from 'ag-grid-enterprise'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const uaIapEltvDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'uaIapEltvd30Avg',
      field: 'ua_iap_eltv_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvd10Avg',
      field: 'ua_iap_eltv_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvd7Avg',
      field: 'ua_iap_eltv_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvd3Avg',
      field: 'ua_iap_eltv_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvd0Avg',
      field: 'ua_iap_eltv_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'UA IAP eLTV',
}
